import BaseInput from './BaseInput'
import Checkboxes from './Checkboxes'
import SelectWidget from './SelectWidget'
import CheckboxWidget from './Checkbox'
import Textarea from './Textarea'

import Radio from './Radio'

import DatePicker from './DatePicker'
import FileUpload6 from './FileUpload6'
import ImageUpload6 from './ImageUpload6'
import { DropdownWidget } from './Dropdown'
import { ToggleList } from './ToggleList'
import DateRangeWidget from './DateRangePicker'
import ButtonGroupWidget from "./ButtonGroupWidget/ButtonGroupWidget"
import InstructionWidget from './InstructionWidget'

export default {
    BaseInput: BaseInput,
    datePicker: DatePicker,
    dateRange: DateRangeWidget,

    fileUpload: FileUpload6,
    imageUpload: ImageUpload6,
    checkboxes: Checkboxes,
    checkbox: CheckboxWidget,
    select: SelectWidget,
    radio: Radio,
    textarea: Textarea,
    dropdown: DropdownWidget,

    toggleList: ToggleList,
    buttonGroup: ButtonGroupWidget as any,
    instruction: InstructionWidget,

};
